import request from '@/middleware/request'

const searchPromptByCode = data => {
  return request({
    url: '/prompts/voice/prompt/search/code',
    method: 'post',
    data
  })
}

const searchBotPromptById = data => {
  return request({
    url: '/prompts//voice/bot_prompt/search/id',
    method: 'post',
    data
  })
}

const getVoicePromptAll = () => {
  return request({
    url: '/prompts/voice/all',
    method: 'get'
  })
}

const getVoicePrompt = data => {
  return request({
    url: '/prompts/voice/list',
    method: 'post',
    data
  })
}

const createVoicePrompt = data => {
  return request({
    url: '/prompts/voice',
    method: 'post',
    data
  })
}

const updateVoicePrompt = (id, data) => {
  return request({
    url: `/prompts/voice/${id}`,
    method: 'patch',
    data
  })
}

const deleteVoicePrompt = id => {
  return request({
    url: `/prompts/voice/${id}`,
    method: 'delete'
  })
}

const getVoicePath = () => {
  return request({
    url: `/prompts/voice/path`,
    method: 'get'
  })
}

const getParameter = () => {
  return request({
    url: `/prompts/parameters`,
    method: 'get'
  })
}

export default {
  getVoicePromptAll,
  getVoicePrompt,
  createVoicePrompt,
  updateVoicePrompt,
  deleteVoicePrompt,
  getVoicePath,
  getParameter,
  searchPromptByCode,
  searchBotPromptById
}
